import React from "react";
import auth from "../firebase.init";
import {
  useAuthState,
  useSignInWithGoogle,
  useSignInWithEmailAndPassword,
} from "react-firebase-hooks/auth";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import HeaderBottom from "../components/HomePage/HeaderBottom";

const Login = () => {
  // Firebase hooks
  const [signInWithGoogle, gUser, gLoading, gError] =
    useSignInWithGoogle(auth);
  const [signInWithEmailAndPassword, eUser, eLoading, eError] =
    useSignInWithEmailAndPassword(auth);
  const [profile] = useAuthState(auth);

  const navigate = useNavigate();

  // React Hook Form setup
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();

  // Handle Email/Password Login
  const onSubmit = (data) => {
    const { email, password } = data;
    signInWithEmailAndPassword(email, password);
  };

  // Navigate after login success
  if (profile || gUser || eUser) {
    navigate("/dashboard");
  }

  return (
    <>
      <HeaderBottom />
      <section className="vh-100 gradient-custom">
        <div className="container py-5 h-100">
          <div className="row d-flex justify-content-center align-items-center h-100">
            <div className="col-12 col-md-8 col-lg-6 col-xl-5">
              <div
                className="bg-primary text-white"
                style={{ borderRadius: "1rem" }}
              >
                <div className="card-body p-5 text-center">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="mb-md-5 mt-md-4 pb-5">
                      <h2 className="fw-bold mb-2 text-uppercase text-white">
                        Login
                      </h2>
                      <p className="text-white-50 mb-5">
                        Please enter your login and password!
                      </p>

                      {/* Email Input */}
                      <div className="form-outline form-white mb-4">
                        <label className="form-label" htmlFor="emailInput">
                          Email
                        </label>
                        <input
                          type="email"
                          className="form-control form-control-lg"
                          id="emailInput"
                          placeholder="Enter your Email"
                          {...register("email", {
                            required: "Email is required",
                            pattern: {
                              value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                              message: "Provide a valid Email",
                            },
                          })}
                        />
                        {errors.email && (
                          <p className="text-danger">{errors.email.message}</p>
                        )}
                      </div>

                      {/* Password Input */}
                      <div className="form-outline form-white mb-4">
                        <label className="form-label" htmlFor="passwordInput">
                          Password
                        </label>
                        <input
                          type="password"
                          className="form-control form-control-lg"
                          id="passwordInput"
                          placeholder="Enter your password"
                          {...register("password", {
                            required: "Password is required",
                            minLength: {
                              value: 6,
                              message: "Minimum 6 Characters",
                            },
                          })}
                        />
                        {errors.password && (
                          <p className="text-danger">
                            {errors.password.message}
                          </p>
                        )}
                      </div>

                      {/* Forgot Password */}
                      <p className="small mb-5 pb-lg-2">
                        <Link to="/reset" className="text-white-50">
                          Forgot password?
                        </Link>
                      </p>

                      {/* Submit Button */}
                      <button
                        className="btn btn-outline-light btn-lg px-5 circle btn-theme-effect"
                        type="submit"
                      >
                        {eLoading ? "Logging in..." : "Login"}
                      </button>

                      {/* Error Messages */}
                      {(eError || gError) && (
                        <p className="text-danger mt-3">
                          {eError?.message || gError?.message}
                        </p>
                      )}

                      <hr className="hr-text mt-4" data-content="OR" />

                      {/* Google Login */}
                      <div className="d-flex justify-content-center text-center mt-4 pt-1">
                        <button
                          type="button"
                          className="btn btn-outline text-white"
                          onClick={() => signInWithGoogle()}
                        >
                          <i className="fab fa-google fa-lg" /> Sign in with
                          Google
                        </button>
                      </div>
                    </div>
                  </form>

                  {/* Register Link */}
                  <div>
                    <p className="mb-0">
                      Don't have an account?{" "}
                      <Link to="/register" className="text-white-50 fw-bold">
                        Sign Up
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Login;
